import React, { useContext } from 'react';
import { FaPlus, FaMinus, FaTrash } from 'react-icons/fa';
import { BASE_URL } from '../../../../BaseUrl';
import { currencySymbolLeft, getSystemSettings } from '../../../../functions/Functions';
import { SettingsContext } from '../../../../contexts/Settings';

const MenuItem = ({ item, cartItem, onAddToCart, isOrderPunchingEnabled, onRemoveFromCart, showImage = true }) => {

  const { generalSettings } = useContext(SettingsContext)

  const handleDisable = (foodItem) => {
    const isDisabled = !!((generalSettings &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      (foodItem?.available_qty <= 0 || foodItem?.available_qty === undefined) &&
      foodItem?.is_deal === 0 && !foodItem?.is_recipe))
    return isDisabled;
  }

  const Isshowtags = (foodItem) => {
    return (
      generalSettings &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      foodItem?.is_deal === 0 &&
      !foodItem?.is_recipe
    );
  };

  const renderStockQty = (foodItem) => {
    if (!foodItem) return null;

    if (foodItem?.available_qty <= 0 || foodItem?.available_qty === undefined) {
      return (
        <span className="modern-tag out-of-stock" >Out of stock</span>
      );
    } 
    // else {
    //   return (
    //     <span className="modern-tag in-stock" > Qty : {" " + Number(foodItem?.available_qty)}</span>
    //   );
    // }
  }

  return (
    <div 
      className={`modern-item-card cursor-pointer bg-white d-flex flex-column ${handleDisable(item) ? "disabled" : ""}`}
      onClick={() => onAddToCart(item)}
    >
      {/* Omit the whole image area when disabled so no blank or fallback block remains. */}
      {showImage && <div className="item-image-wrapper position-relative">
        <img
          src={item.image ? BASE_URL + item.image : "/assets/img/default-item.jpeg"} 
          alt={item.name} 
          className="item-image" 
          loading="lazy"
          onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/default-item.jpeg" }}
        />
        {Isshowtags(item) &&
          <div className="modern-tag-overlay">
            {renderStockQty(item)}
          </div>
        }
        {
          isOrderPunchingEnabled ? (
            <div className="position-absolute add-btn-container">
                {!cartItem ? (
                  <button 
                    className="btn rounded-circle shadow-sm d-flex align-items-center justify-content-center p-0 add-btn-circle" 
                    onClick={(e) => { e.stopPropagation(); onAddToCart(item); }}
                  >
                    <FaPlus className="add-btn-icon" />
                  </button>
                ) : (
                  <div className="d-flex align-items-center rounded-pill shadow-sm add-btn-pill">
                    <button className="btn btn-sm border-0 text-white d-flex align-items-center add-btn-pill-btn" onClick={(e) => { e.stopPropagation(); onRemoveFromCart(item); }}>
                      {cartItem.quantity === 1 ? <FaTrash className="add-btn-icon-small" /> : <FaMinus className="add-btn-icon-small" />}
                    </button>
                    <span className="font-weight-md text-white cart-quantity-text">
                      {cartItem.quantity}
                    </span>
                    <button className="btn btn-sm border-0 text-white d-flex align-items-center add-btn-pill-btn" onClick={(e) => { e.stopPropagation(); onAddToCart(item); }}>
                      <FaPlus className="add-btn-icon-small" />
                    </button>
                  </div>
                )}
            </div>
          ) : ""
        }
      </div>}
      <div className="item-details flex-grow-1 d-flex flex-column text-center">
        <div className="item-name-wrapper">{item.name}</div>
        <div className="item-price-wrapper mt-auto">
          <span className="">{currencySymbolLeft()} {(item?.has_variation === "1" && Array.isArray(item.variations)) ? item.variations[0]?.food_with_variation_price : item.price}</span>
        </div>
      </div>
    </div>
  );
};

export default MenuItem;
